"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var StoreEntity_1 = __importDefault(require("../../Core/StoreEntity"));
var Rollouts_consts_1 = require("../Rollouts.consts");
var RolloutsEntity = /** @class */ (function (_super) {
    __extends(RolloutsEntity, _super);
    function RolloutsEntity(session) {
        return _super.call(this, { session: session, entityName: 'rollouts', routes: [] }) || this;
    }
    RolloutsEntity.prototype.getAll = function () {
        return this.service.routeGenerator
            .get(Rollouts_consts_1.Routes.getAll)
            .withExtractor(function (response) { return response.result; })
            .invoke();
    };
    RolloutsEntity.prototype.createOrUpdateUserRollout = function (params) {
        return this.service.routeGenerator
            .post(Rollouts_consts_1.Routes.createOrUpdateUserRollout)
            .withPayload(params)
            .withExtractor(function (response) { return response.result; })
            .invoke();
    };
    return RolloutsEntity;
}(StoreEntity_1.default));
exports.default = RolloutsEntity;
//# sourceMappingURL=RolloutsEntity.js.map